import axios from 'axios';
import store from '@/store';

export const apiredeciclo = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
});

// request header
apiredeciclo.interceptors.request.use(
  config => {
    store.commit('updateLoaderState', true);
    return config;
  },
  error => {
    store.commit('updateLoaderState', true);
    return Promise.reject(error);
  },
);

// response parse
apiredeciclo.interceptors.response.use(
  response => {
    store.commit('updateLoaderState', false);
    return response;
  },
  error => {
    store.commit('updateLoaderState', false);
    console.error('Error status', error.response.status);
    if (error.response) {
      return error.response.data;
    }
    return Promise.reject(error);
  },
);

export const http = axios.create({
  timeout: 10000,
});

// request header
http.interceptors.request.use(
  config => {
    store.commit('updateLoaderState', true);
    return config;
  },
  error => {
    store.commit('updateLoaderState', true);
    return Promise.reject(error);
  },
);

// response parse
http.interceptors.response.use(
  response => {
    store.commit('updateLoaderState', false);
    return response;
  },
  error => {
    store.commit('updateLoaderState', false);
    console.error('Error status', error.response.status);
    if (error.response) {
      return error.response.data;
    }
    return Promise.reject(error);
  },
);
